module.exports = __webpack_public_path__ + "static/media/Uganda.2a090516.png";